(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-bundles"]) return;
  try {
    
var loadProductBundle = function() {
  var bundlesSection = document.querySelector('.js-bundle');
  if (bundlesSection === null) { return; }

  var productId = bundlesSection.dataset.productId;
  var baseUrl = bundlesSection.dataset.baseUrl;
  var limit = bundlesSection.dataset.limit;
  var requestUrl = baseUrl + "?section_id=product-bundles&product_id=" + productId + "&limit=" + limit;

  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);

  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      var recommendations = container.querySelector('.js-bundle-recommendations');

      if (recommendations === null) return;

      var bundleList = bundlesSection.querySelector('.js-bundle-list');
      var oldProductItems = bundleList.querySelectorAll('.js-bundle-item:not(.js-bundle-item-current)');
      var newProducItems = recommendations.querySelectorAll('.js-bundle-item');

      for (var i = 0; i < oldProductItems.length; i++) {
        bundleList.removeChilde(oldProductItems[i]);
      }

      for (var i = 0; i < newProducItems.length; i++) {
        bundleList.appendChild(newProducItems[i]);
      }

      var loadedEvent = new Event('loaded');
      bundlesSection.dispatchEvent(loadedEvent);
    }
  };

  request.send();
};

document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-bundles") {
    loadProductBundle();
  }
});

loadProductBundle();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      const updatedEvent = new Event('tsh::recommended-updated');
      document.dispatchEvent(updatedEvent);
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
